import * as yup from 'yup';

export const usersValidation = yup.object({
  name: yup.string('Enter Name').required('Name is required'),
  email: yup
    .string('Enter email')
    .email('Enter a valid email') // ✅ Ensures proper email format
    .required('Email is required'),
    password: yup
    .string('Enter password')
    .required('Password is required'),
    role: yup
    .string('Enter role')
    .required('Role is required'),
});


